<template>
  <div class="_w-max _pc-pad-y-75 _flex-col">
    <div class="animate__animated animate__bounceInUp">
      <AboutUs />
    </div>
    <div :class="scrollTop > 500 ? 'animate__animated animate__fadeInLeft' : ''">
      <Contact />
    </div>
    <div :class="scrollTop > 1500 ? 'animate__animated animate__fadeInRight' : ''">
      <Message />
    </div>

  </div>
</template>

<script>
import AboutUs from "@/pages/about/components/AboutUs";
import Contact from "@/pages/about/components/Contact";
import Message from "@/pages/about/components/Message";
export default {
  name: "IndexAbout",
  components: { Message, Contact, AboutUs },
  data() {
    return {
      scrollTop: 0,//页面滑动距离
    };
  },
  metaInfo: {
    title: '星辰万里集运 - 跨国集运专家 | 海外华人留学生集运服务',
    meta: [{
      name: 'Keywords',
      content: '星辰万里集运, 包裹集运, 国货集运, 海外华人集运, 留学生集运服务, 淘宝双十一集运, 淘宝转运, 淘宝转寄海外, 淘宝集中转运, 集运服务, 中国到海外集运'
    },
    {
      name: 'Description',
      content: '星辰万里集运，您的跨国集运专家。专为海外华人和留学生提供便捷、高效的集运服务。无论您身在何处，享受家乡商品的乐趣。轻松、快捷、安全，让您的海外生活更加丰富多彩。加入我们，探索更多集运优惠和服务。'
    }]
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
  },
  methods: {
    // 获取页面滚动距离
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    },
  }
};
</script>

<style scoped></style>
